export const FETCH_APPAREL_ITEMS = 'ADMIN_APPAREL_ITEMS/FETCH_APPAREL_ITEMS';
export const FETCH_APPAREL_ITEMS_SUCCESS = 'ADMIN_APPAREL_ITEMS/FETCH_APPAREL_ITEMS_SUCCESS';
export const FETCH_APPAREL_ITEMS_ERROR = 'ADMIN_APPAREL_ITEMS/FETCH_APPAREL_ITEMS_ERROR';
export const FETCH_DEPARTMENTS = 'ADMIN_APPAREL_ITEMS/FETCH_DEPARTMENTS';
export const FETCH_DEPARTMENTS_SUCCESS = 'ADMIN_APPAREL_ITEMS/FETCH_DEPARTMENTS_SUCCESS';
export const FETCH_DEPARTMENTS_ERROR = 'ADMIN_APPAREL_ITEMS/FETCH_DEPARTMENTS_ERROR';
export const SAVE_APPAREL_ITEM = 'ADMIN_APPAREL_ITEMS/SAVE_APPAREL_ITEM';
export const SAVE_APPAREL_ITEM_SUCCESS = 'ADMIN_APPAREL_ITEMS/SAVE_APPAREL_ITEM_SUCCESS';
export const SAVE_APPAREL_ITEM_ERROR = 'ADMIN_APPAREL_ITEMS/SAVE_APPAREL_ITEM_ERROR';
export const DELETE_APPAREL_ITEM = 'ADMIN_APPAREL_ITEMS/DELETE_APPAREL_ITEM';
export const DELETE_APPAREL_ITEM_SUCCESS = 'ADMIN_APPAREL_ITEMS/DELETE_APPAREL_ITEM_SUCCESS';
export const DELETE_APPAREL_ITEM_ERROR = 'ADMIN_APPAREL_ITEMS/DELETE_APPAREL_ITEM_ERROR';
export const UPLOAD_FILE = 'ADMIN_APPAREL_ITEMS/UPLOAD_FILE';
export const UPLOAD_FILE_SUCCESS = 'ADMIN_APPAREL_ITEMS/UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_ERROR = 'ADMIN_APPAREL_ITEMS/UPLOAD_FILE_ERROR';
export const SET_ID_MODAL = 'ADMIN_APPAREL_ITEMS/SET_ID_MODAL';
export const SET_ACTIVE_PAGE = 'ADMIN_APPAREL_ITEMS/SET_ACTIVE_PAGE';
export const RESET_STATE = 'ADMIN_APPAREL_ITEMS/RESET_STATE';
export const SET_APPAREL_ITEM = 'ADMIN_APPAREL_ITEMS/SET_APPAREL_ITEM';
export const SET_APPAREL_ITEM_FIELD = 'ADMIN_APPAREL_ITEMS/SET_APPAREL_ITEM_FIELD';
export const SET_TILE_IMAGE = 'ADMIN_APPAREL_ITEMS/SET_TILE_IMAGE';
export const SET_IMAGE1 = 'ADMIN_APPAREL_ITEMS/SET_IMAGE1';
export const SET_IMAGE2 = 'ADMIN_APPAREL_ITEMS/SET_IMAGE2';
export const SET_IMAGE3 = 'ADMIN_APPAREL_ITEMS/SET_IMAGE3';
export const RESET_APPAREL_ITEM = 'ADMIN_APPAREL_ITEMS/RESET_APPAREL_ITEM';
export const SET_SORT = 'ADMIN_APPAREL_ITEMS/SET_SORT';
export const SET_SEARCH = 'ADMIN_APPAREL_ITEMS/SET_SEARCH';
export const SET_SEARCH_TYPE = 'ADMIN_APPAREL_ITEMS/SET_SEARCH_TYPE';
export const SET_UPLOAD_FILE = 'ADMIN_APPAREL_ITEMS/SET_UPLOAD_FILE';
export const ADD_DEPARTMENT = 'ADMIN_APPAREL_ITEMS/ADD_DEPARTMENT';
export const SET_SHOW_UTP = 'ADMIN_APPAREL_ITEMS/SET_SHOW_UTP';
export const SET_SHOW_UTH = 'ADMIN_APPAREL_ITEMS/SET_SHOW_UTH';
export const DELETE_DEPARTMENT = 'ADMIN_APPAREL_ITEMS/DELETE_DEPARTMENT';